import { ref } from 'vue';
const phoneSize=ref(true)
  const updatePhoneSize = () => {
    phoneSize.value = window.innerWidth < 1024;
  };
  updatePhoneSize();
  window.addEventListener('resize', updatePhoneSize);
export function isPhoneSize() {
  
    return phoneSize.value;
  }